module.exports = __webpack_public_path__ + "media/images/lb/745-6acbb2523f9025b9fb957431abe47a16.svg";